// extracted by mini-css-extract-plugin
export default {"video":"HlsVideo_video__gZ95Z"};